module.exports = __webpack_public_path__ + "static/undraw_factory_dy0a-b21810d220edbba6c9afb2e6175e99f7.svg";